import { useMemo } from "react"
import { InputPrefix } from "src/components/projetos/dimensionados/containers/Configuracoes/components/InputPrefix"
import { Projeto } from "src/components/projetos/types"
import { validacaoFatorDePerdas } from "src/components/projetos/utils/validarFatorDePerdas"
import { InputDecimal3 } from "src/framework/components/forms/inputs/InputDecimal3"

interface InputFatorDePerdasProps {
  formState: Projeto
  setFormState: (newState: Partial<Projeto>) => void
  setIsValid: (isValid: { msg: string; status: boolean }) => void
}

export function InputFatorDePerdas({ formState, setFormState, setIsValid }: InputFatorDePerdasProps){
  const isValid = useMemo((): ReturnType<typeof validacaoFatorDePerdas> => {
    const result = validacaoFatorDePerdas(formState.fator_perdas, formState.tipo_inversor?.value || 0)
    setIsValid(result)
    return result
  },[formState.fator_perdas, formState.tipo_inversor?.value, setIsValid])

  return (
    <InputDecimal3
      label="* Fator de perdas (%)"
      helperText={!isValid.status ? isValid.msg : ""}
      margin="normal"
      prefix={<InputPrefix styles={{ marginLeft: '-9px' }} />}
      decimal={2}
      error={isValid.status === false || !formState.fator_perdas}
      maxLength={5}
      allowNegative={false}
      value={formState.fator_perdas || ''}
      onChange={(event: any) => {
        setFormState({ fator_perdas: event.target.value })
      }}
    />
  )
}
